import 'mmbclient/Components/CircularSpinner.css'; // Import your custom CSS

const CircularSpinner = () => {
    return (
        <div className="overlay d-flex justify-content-center align-items-center">
            <div className="spinner-border" role="status" aria-hidden="true" />
        </div>
    );
};

export default CircularSpinner;
